import React from "react";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Typography from "@mui/material/Typography";
import { CardActionArea } from "@mui/material";
import Grid from "@mui/material/Grid";
import dayOne from "../../images/4.0/day1/Cover Image.jpg";
import dayTwo from "../../images/4.0/day2/0 Introduction.jpg";
import dayThree from "../../images/4.0/day3/0. Introduction.jpg";

const cardData = [
  {
    header: "Day One",
    textPrimary:
      "An Introduction to the Corruptible seed and the Incorruptible seed",
    textSecondary: "null",
    path: "day-one",
    img: dayOne,
  },
  {
    header: "Day Two",
    textPrimary: "The Meat of the Word; God's provision to arrest corruption",
    textSecondary: "null",
    path: "day-two",
    img: dayTwo,
  },
  {
    header: "Day Three",
    textPrimary:
      "The Strong Meat, God’s provision to immune the soul from corruption",
    textSecondary: "null",
    path: "day-three",
    img: dayThree,
  },
];

export default function FourHome() {
  return (
    <Grid container spacing={4}>
      {cardData.map((item) => (
        <Grid key={item.header} item xs={12} lg={4}>
          <Card>
            <CardActionArea href={item.path}>
              <CardMedia
                component="img"
                height="150"
                image={item.img}
                alt={item.header}
              />
              <CardContent>
                <Typography gutterBottom variant="body1" color="text.secondary">
                  {item.header}
                </Typography>
                <Typography variant="h6" component="div" fontWeight="regular">
                  {item.textPrimary}
                </Typography>
                <Typography
                  variant="subtitle2"
                  color={
                    item.textSecondary === "null" ? "white" : "text.secondary"
                  }
                >
                  {item.textSecondary}
                </Typography>
              </CardContent>
            </CardActionArea>
          </Card>
        </Grid>
      ))}
    </Grid>
  );
}
